import { takeLatest, call, put, all } from "redux-saga/effects";
import { showError } from "../../../utils/snackbarRef";
import Options from "../../../utils/options";
import history from "../../../services/history";
import api from "../../../services/api";

import { signInSuccess, signInFailure, mapaInSucess } from "./actions";

// export function* signIn({ payload }) {
//   const { email, password } = payload;
//   const response = yield call(api.post, "usersessions", {
//     email,
//     password,
//   });
//   try {

//     const { token, labs_data,...rest } = response.data;
//     api.defaults.headers.Authorization = `Bearer ${token}`;

//     yield put(
//       signInSuccess(token, rest, {
//         data: labs_data,
//       },
//       )
//     );

//     rest.responsabilidade === Options.profileResponsabilites.admin ||
//     rest.responsabilidade === Options.profileResponsabilites.sudo
//       ? history.push("/dashadmin")
//       : history.push("/dashboard");
//   } catch (err) {
//     message.error(err.response.data.error);
//     yield put(signInFailure());
//   }
// }

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token}`;
  }

  // Validar que o profile rehidratado é um objeto válido
  const profile = payload.user?.profile;
  if (profile && (typeof profile !== 'object' || !profile.id)) {
    // Profile corrompido (string HTML, null, etc) — limpar e forçar re-login
    console.warn('[Auth] Profile corrompido no localStorage, limpando...');
    const persistKey = Object.keys(localStorage).find((k) => k.includes('persist'));
    if (persistKey) {
      try {
        const data = JSON.parse(localStorage.getItem(persistKey));
        if (data.user) {
          const user = JSON.parse(data.user);
          user.profile = null;
          data.user = JSON.stringify(user);
          localStorage.setItem(persistKey, JSON.stringify(data));
        }
      } catch (e) { /* silencia */ }
    }
  }
}

export function signOut() {
  history.push("/");
}

export function* sigInMapa() {
  try {
    const response = yield call(api.post, "/mapa", {});

    const { token } = response.data;

    // yield put(mapaInSucess(token));
  } catch (err) {
    showError(err?.response?.data?.error || "Erro ao acessar o mapa");
  }
}

export default all([
  takeLatest("persist/REHYDRATE", setToken),
  // takeLatest("@auth/SIGN_IN_REQUEST", signIn),
  takeLatest("@auth/SIGN_OUT", signOut),

  takeLatest("@auth/MAPA_IN_REQUEST", sigInMapa),
  // takeLatest("@auth/SIGN_UP_REQUEST", signUp)
]);
